import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  popup: {
    wrapper: {
      position: 'fixed',
      zIndex: theme.settings.zLayers.portal,
    },
    isPositioned: {
      opacity: 0,
      pointerEvents: 'none',
    },
    base: {
      borderRadius: theme.settings.borderRadiuses.regular,
      border: theme.settings.borders.regular,
      boxShadow: theme.settings.shadows.medium,
    },
    variants: {
      dark: {
        color: theme.colors.text.light,
        backgroundColor: theme.colors.backgrounds.dark,
        ':before': {
          borderBottomColor: theme.colors.backgrounds.dark,
          borderTopColor: theme.colors.backgrounds.dark,
        },
      },
      default: {
        backgroundColor: theme.colors.backgrounds.main,
      },
    },
    outside: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: theme.settings.zLayers.portal - 1,
      width: '100vw',
      height: '100vh',
    },
  },
})
